/*****************************************************/
/* 処　理：SMS002 契約情報 画面
/*
/* 概　要：定数定義
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/

// 処理名
export const INIT_NAME = '初期表示';
export const BTN_EXECUTE_NAME = '送信';
export const BTN_BACKMENU_NAME = 'メニューへ戻る';

// APIパス
export const API_INIT_PATH = '/SMS002/init';
export const API_EXECUTE_PATH = '/SMS002/execute';

// 外部サイトURL
export const URL_NETKOUZA = 'https://www.orico-fi.co.jp/netkouza.html'
